import {Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import {
  MsalBroadcastService,
  MsalService,
} from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { Subject} from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {

  constructor(
      public broadcastService: MsalBroadcastService,
      public authService: MsalService,
      private _elementRef: ElementRef
  ) {}

  flag: boolean = false;
  private readonly _destroying$ = new Subject<void>();

  msalSubjectSubscriber = (result: EventMessage) => {
    if (this.authService.instance.getAllAccounts().length === 0) {
      window.localStorage['pathname'] = '/';
    }
  };
  ngOnInit(){
    this.authService.instance.initialize();
    this._elementRef.nativeElement.removeAttribute('ng-version');
    this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.broadcastService.msalSubject$
        .pipe(
            filter(
                (msg: EventMessage) =>
                    msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED
            )
        )
        .subscribe(this.msalSubjectSubscriber);

    this.broadcastService.inProgress$
        .pipe(
            filter((status: InteractionStatus) => status === InteractionStatus.None),
            takeUntil(this._destroying$)
        )
        .subscribe(() => {
          this.checkAndSetActiveAccount();
        });
  }

  checkAndSetActiveAccount() {
    const activeAccount = this.authService.instance.getActiveAccount();
    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      const accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  logout() {
    this.authService.logoutRedirect();
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}
